export enum NTCacheInitPhase {
    NOT_INITIALIZED, PENDING, INITIALIZED
}
